import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var SvgTextUnderline = function SvgTextUnderline(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: [_jsx("path", {
      fill: props.color || '#909090',
      d: "M7.997 10.406c.347 0 .656-.059.927-.178.276-.118.507-.285.694-.499a2.13 2.13 0 0 0 .434-.78 3.22 3.22 0 0 0 .153-1.026V2.897a.897.897 0 0 1 1.795 0v5.026a4.64 4.64 0 0 1-.28 1.635 3.703 3.703 0 0 1-.794 1.293c-.347.36-.768.643-1.261.848A4.41 4.41 0 0 1 7.997 12c-.619 0-1.175-.1-1.668-.301a3.695 3.695 0 0 1-1.261-.848 3.837 3.837 0 0 1-.794-1.293A4.75 4.75 0 0 1 4 7.923V2.897a.897.897 0 0 1 1.795 0v5.02c0 .378.049.72.147 1.026.102.305.246.567.433.786.187.214.416.38.688.5.275.118.587.177.934.177Z"
    }), _jsx("path", {
      fill: props.color || '#909090',
      fillRule: "evenodd",
      d: "M2 14a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z",
      clipRule: "evenodd"
    })]
  }));
};

export default SvgTextUnderline;